export default __webpack_public_path__ + "static/media/location_navigation_info.0d4033bd.png";